export const convertToEscapedStringifiedJson = (
  symptoms: string,
  reason: string,
  situation: string,
) => {
  const jsonNote = {
    notes: {
      main_symptoms: symptoms,
      forward_reason: reason,
      current_patient_situation: situation,
    },
  };
  return JSON.stringify(jsonNote).replaceAll('"', '\\"');
};
